import { useState } from 'react';
import ServiceParameter from '@/components/ServiceParameter';
import { ENGRAVED_PARAMETER, ENGRAVED_TYPE, TEXT_PARAMETER } from './constants';

const { ORDER_NAME, CUSTOM_TEXT } = ENGRAVED_TYPE;

type EngravedType = keyof typeof ENGRAVED_TYPE;

export type EngravementFormProps = {
  engravedText: string;
  onChange: (engravedText: string) => void;
};

export default function EngravementForm({
  engravedText,
  onChange,
}: EngravementFormProps) {
  const [engravedType, setEngravedType] = useState<EngravedType>(ORDER_NAME);

  const handleChangeType = (value: EngravedType) => {
    if (value === engravedType) return;
    setEngravedType(value);
    onChange(value === ORDER_NAME ? 'engrave_order_name' : '');
  };

  return (
    <>
      <ServiceParameter
        parameter={ENGRAVED_PARAMETER}
        value={engravedType}
        onChange={(update) =>
          handleChangeType(
            (update as Record<'engravedOptions', EngravedType>).engravedOptions
          )
        }
      />
      {engravedType === CUSTOM_TEXT && (
        <ServiceParameter
          parameter={TEXT_PARAMETER}
          value={engravedText}
          onChange={(update) => onChange(update.engravedText as string)}
        />
      )}
    </>
  );
}
